import React, { useState } from "react";
import "./styles.scss";

export interface ToggleOption {
  id: string;
  label: string;
}

export interface DoubleToggleProps {
  leftOption: ToggleOption;
  rightOption: ToggleOption;
  initialValue?: string; // id of the initially selected option
  selectedOptionId?: string;
  onChange?: (value: string) => void;
  className?: string;
}

export const DoubleToggle: React.FC<DoubleToggleProps> = ({
  leftOption,
  rightOption,
  initialValue = "left",
  selectedOptionId,
  onChange,
  className = "",
}) => {
  const [activeId, setActiveId] = useState<string>(
    selectedOptionId || initialValue || leftOption.id
  );

  const handleToggle = (optionId: string) => {
    if (optionId !== activeId) {
      setActiveId(optionId);
      onChange?.(optionId);
    }
  };

  return (
    <div className={`double-toggle ${className}`}>
      <span
        className={`toggle-option left-option ${
          activeId === leftOption.id ? "active" : ""
        }`}
        onClick={() => handleToggle(leftOption.id)}
      >
        {leftOption.label}
      </span>

      <div
        className="toggle-switch"
        onClick={() =>
          handleToggle(
            activeId === leftOption.id ? rightOption.id : leftOption.id
          )
        }
      >
        <div
          className={`toggle-knob ${
            activeId === leftOption.id ? "left-knob" : "right-knob"
          }`}
        />
      </div>

      <span
        className={`toggle-option right-option ${
          activeId === rightOption.id ? "active" : ""
        }`}
        onClick={() => handleToggle(rightOption.id)}
      >
        {rightOption.label}
      </span>
    </div>
  );
};
